import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';

export default InjectedStyledComponent('section', 'app', ['wrapper']);
